export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11525.5d836653.jpg";